import { defineStore } from "pinia";
import { ref, reactive } from "vue";
import { fetchUserInfo, fetchLogout, fetchUserLogin } from "@/http/login/login";
import { fetchStudentInfo } from "@/http/student/login";
import { useLanguageEnum } from "@/hooks/useLanguageEnum";
import _, { cloneDeep } from "lodash";
import { detectDevice, isMobileDevice } from "@/libs/deviceDetector";
import router from "@/router/route";
import { updateCurrentUserIdentifier } from "@/libs/crossTabSync";

export const useUserInfo = defineStore("user", () => {
  // 状态
  const userInfo = ref();
  const loading = ref(false);
  const error = ref(null);
  const initialized = ref(false);

  // 从本地存储初始化用户数据
  const initFromLocalStorage = () => {
    const storedUser = localStorage.getItem("userInfo");
    if (storedUser) {
      try {
        userInfo.value = JSON.parse(storedUser);
      } catch (e) {
        console.error("Failed to parse userInfo from localStorage", e);
      }
    }
  };

  // 初始化时尝试从本地存储加载
  initFromLocalStorage();

  // 获取用户信息
  const fetchUsers = async () => {
    try {
      const loginType = localStorage.getItem("loginType");
      const response = loginType === "student" ? await fetchStudentInfo() : await fetchUserInfo();
      if (response.code === 200) {
        // 更新用户信息
        const studentData = {
          nickName: response.data.name,
          nickNameEn: response.data.nameEn,
          userName: response.data.email,
          ...response.data,
          roleKey: "ROLE_STUDENT"
        };
        const teacherData = {
          ...response.data,
          roleKey: response.data.institutionId ? "ROLE_ORG_TEACHER" : response.data.roleKey
        };
        updateUserInfo(loginType === "student" ? studentData : teacherData);
        return true;
      }
      return false;
    } catch (error) {
      console.error("Fetch user info failed:", error);
      return false;
    }
  };

  // 更新用户信息的统一方法
  const updateUserInfo = (newUserData: any) => {
    return;
    userInfo.value = newUserData;
    localStorage.setItem("userInfo", JSON.stringify(newUserData));
    updateCurrentUserIdentifier();
    // 更新语言设置
    // if (newUserData?.languageCode) {
    //   localStorage.setItem("locale", newUserData?.languageCode);
    // }
  };

  const initializeUser = async () => {
    if (localStorage.getItem("accessToken") && window.location.pathname != "/login") {
      await fetchUsers();
      initialized.value = true;
    }
  };

  // 清除用户数据
  const clearUserData = () => {
    userInfo.value = null;
    initialized.value = false;
    sessionStorage.clear();

    localStorage.removeItem("userInfo");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("accessTokenExpireAt");
    localStorage.removeItem("refreshTokenExpireAt");
    localStorage.removeItem("personal-info");
    localStorage.removeItem("currentUserId");
    if (!localStorage.getItem("remember_password_mark")) {
      localStorage.removeItem("remember_password");
    }
  };

  const logout = () => {
    const loginType = localStorage.getItem("loginType");
    if (window.location.pathname != "/login") {
      clearUserData();
      router.replace("/login");
    }
  };
  const onLogin = async (form: any) => {
    try {
      const formData: any = new FormData();
      formData.append("userName", form.userName);
      formData.append("password", form.password);
      formData.append("loginType", 1);
      formData.append("platType", isMobileDevice() ? "H5" : "web");
      const res = await fetchUserLogin(formData);
      if (res.code === 200) {
        window.localStorage.setItem("remember_login_name", form.userName);
        // 存储完整的令牌数据
        const tokenData = {
          accessToken: res.data.accessToken,
          refreshToken: res.data.refreshToken,
          accessTokenExpire: res.data.accessTokenExpire, // 秒数
          refreshTokenExpire: res.data.refreshTokenExpire // 秒数
        };

        // 计算并存储绝对过期时间
        const now = Date.now();
        localStorage.setItem("accessToken", tokenData.accessToken);
        localStorage.setItem("refreshToken", tokenData.refreshToken);
        localStorage.setItem(
          "accessTokenExpireAt",
          String(now + tokenData.accessTokenExpire * 1000)
        );
        localStorage.setItem(
          "refreshTokenExpireAt",
          String(now + tokenData.refreshTokenExpire * 1000)
        );
        localStorage.setItem(
          "personal-info",
          JSON.stringify({
            token: tokenData.accessToken
          })
        );
        return true;
      }
    } catch (e) {
      return false;
    }
  };

  // // 计算属性
  // const isAdmin = computed(() => {
  //   return userInfo.value?.role === 'admin'
  // })

  return {
    userInfo,
    initializeUser,
    fetchUsers,
    clearUserData,
    logout,
    onLogin,
    updateUserInfo
  };
});
